<template>
  <v-dialog
    v-model="dialog"
    no-click-animation
    persistent
    width="500"
    :transition="false"
  >
    <v-card>
      <v-card-title>
        {{ $t('profile.actionReq') }}
      </v-card-title>
      <v-card-text>
        {{ $t('profile.fillProfileProcess') }}
      </v-card-text>
      <v-divider />

      <v-card-actions>
        <v-spacer />
        <v-btn
          outlined
          text
          @click="go()"
        >
          {{ $t('profile.gotoProfile') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'HelperFillProfile',
  data: () => ({
    dialog: false
  }),
  methods: {
    open() {
      this.dialog = true;
    },
    go() {
      this.dialog = false
      this.$router.push('/profile')
    }
  }

}
</script>

<style lang="scss" scoped>
</style>
